import { createContext, useContext } from 'react';

var e={size:"regular"},t=createContext(e),x=t.Provider,i=()=>useContext(t)||e;

export { x as a, i as b };
